/*global $*/
$(function() {
  $('.language-selector, .country-setting-selector').change(function() {
    location.href = this.value
  })
})